import React, { useContext } from 'react';
import AppContext from '../context/context';

import PortfolioCard from '../components/portfolioCard';


const Portfolio = () => {
	
	const context = useContext(AppContext)

	return(

				<div className="row">
				
					<div className="col-lg-10">
						
						
						
						<h1 id="portfolio" aria-hidden="true" style={{marginLeft: "-2px"}} className="mt-4 scroll-margin">Portfólio</h1>
					
						<select aria-hidden="true" className="custom-select mr-sm-2 p-2 mb-3 shadow-none" style={{width: "150px"}} id="inlineFormCustomSelect" value={context.state.language} onChange={context.filterLanguage}>
							<option value="all" aria-hidden="true">Tudo</option>
							<option value="react" aria-hidden="true">React JS</option>
							<option value="next" aria-hidden="true">Next JS</option>
							<option value="python" aria-hidden="true">Flask</option>
							<option value="javascript" aria-hidden="true">HTML, CSS, JS</option>
							<option value="r-lang" aria-hidden="true">R</option>
						</select>
						
						<div className="row">
						
							
							{context.state.portfolio.map((projeto, index) => (projeto.tecnologia === context.state.language || context.state.language === "all") &&
								<PortfolioCard
									key={index}
									imagem={projeto.imagem}
									url={projeto.url}
									descricao={projeto.descricao}
								/>
							)}
					

						</div><br/>
						<center><a id="ir-para-o-topo" onClick={() => context.scrollTo("main")}>Voltar ao topo</a></center>
					</div>
					<div className="col-sm-2"></div>
					
				</div>

	)
}

export default Portfolio;